import { useState, useEffect } from 'react'
import s from './AddOpportunity.scss'
import { AllDashboardComponent } from '../DictionaryDashboard'
import { FaBuilding } from 'react-icons/fa'
import { DealsModal } from 'components/Deals/DealsModal'
import { makeGetRequest } from 'utils/api'
import { useSelector, useDispatch } from 'react-redux'
import { toUsers } from './serializers'
import { useNavigate } from 'react-router-dom'

const AddOpportunity = ({ type, layoutLocked }) => {
  const [isAddDealModalVisible, setIsAddDealModalVisible] = useState(false)
  const storedUsers = useSelector(state => state.users.users)
  const [users, setUsers] = useState(toUsers(storedUsers) || [])
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      if (users.length) return
      const { content } = await makeGetRequest('/v1/users')
      setUsers(toUsers(content))
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const createDeal = (deal, cb) => {
    dispatch({
      type: 'CREATE_DEAL_REQUESTED',
      payload: {
        deal,
        cb,
        fromDashboard: true
      }
    })
  }

  return (
    <>
      <div
        onClick={layoutLocked ? () => setIsAddDealModalVisible(true) : null}
        className={s.wrapper}
        data-cy="add_new_deal"
      >
        <>
          <FaBuilding className={s.icon} />
          <div>
            <h6>{AllDashboardComponent[type].label}</h6>
            <p>
              Enter each project or opportunity in the system to start tracking their status. Once
              entered, your opportunities will be organized on your personalized Opportunities
              Pipeline Board so you know what you need to work on and when.
            </p>
          </div>
          <div className={s.action}>{'Enter Opportunity'.toUpperCase()}</div>
        </>
      </div>
      {isAddDealModalVisible && (
        <DealsModal
          showAddDealModal={isAddDealModalVisible}
          toggleAddDealModal={() => setIsAddDealModalVisible(false)}
          createDeal={createDeal}
          users={users}
          navigate={navigate}
        />
      )}
    </>
  )
}

export default AddOpportunity
